// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Pxmxr","wrapper":"Footer_wrapper__bRbVo","naming":"Footer_naming__-lt8u","list":"Footer_list__MBSEV","link":"Footer_link__1Uqxj"};